import { ElementType, FC } from 'react';
import { SvgIconProps } from '@mui/material';
import { WarningAmberOutlined as WarningAmberOutlinedIcon } from '@mui/icons-material';
import IconContainer, { IconContainerProps } from '../../Icon/IconContainer';
import Column from '../../Column';
import Row, { RowProps } from '../../Row';

interface ActionCalloutProps extends RowProps {
    icon?: ElementType<SvgIconProps>;
    color?: IconContainerProps['color'];
    slotProps?: {
        iconContainer?: IconContainerProps;
    };
}

const ActionCallout: FC<ActionCalloutProps> = ({
    children,
    icon = WarningAmberOutlinedIcon,
    color = 'warning',
    slotProps = {},
    ...props
}) => {
    return (
        <Row
            sx={{
                backgroundColor: (theme) => theme.palette.grey[100],
                p: (theme) => theme.spacing(3),
                borderRadius: (theme) => theme.spacing(1),
            }}
            {...props}
        >
            <Column gap={2}>
                <Row>
                    <Row alignItems="center">
                        <IconContainer
                            {...slotProps?.iconContainer}
                            icon={icon}
                            color={color}
                            sx={{ borderWidth: 1 }}
                        />

                        {children}
                    </Row>
                </Row>
            </Column>
        </Row>
    );
};

export type { ActionCalloutProps };
export default ActionCallout;
